import "./App.css";
import { ThemeProvider } from "@mui/material";
import theme from "./styles/theme";
import "./styles/general.css";
import { AppProviders } from "./AppProviders";
import AppRoutes from "./AppRoutes";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <AppProviders>
        <AppRoutes />
      </AppProviders>
    </ThemeProvider>
  );
}
export default App;
